import { createContext, useContext } from 'react'
import type { CollectionViewSettingsModel } from '@/generated/graphql'
import type { ObjectTypeModel, CollectionModel } from '@/core/gql/gql-models-override.ts'

export interface CollectionViewPageContext {
  collectionId: string
  collection: CollectionModel | undefined
  objectType: ObjectTypeModel | undefined
  viewSettings: CollectionViewSettingsModel | undefined
}

export const CollectionViewPageContext = createContext<CollectionViewPageContext | undefined>(
  undefined,
)

export function useCollectionViewContext(): CollectionViewPageContext {
  const ctx = useContext(CollectionViewPageContext)
  if (!ctx) throw new Error('useCollectionPageContext used outside CollectionViewPageContext')
  return ctx
}
